import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Card, Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import UserImg from "../../assets/img/safarioperator1718118346.jpg";
import { useProfileContext } from "provider/ProfileProvider";
import { apiCall2 } from "components/Api/api";
import { formatDateMonthYear } from "components/Api/common";

const Following = () => {
  const { userProfileView, profileDispatch } = useProfileContext();
  const [loading, setLoading] = useState();
  const [following, setFollowingData] = useState([]);

  useEffect(() => {

    const fetchData = async () => {
      try {
        setLoading(true);

        const [followingRes] = await Promise.all([
          apiCall2({
            url: userProfileView?.urls?.followings_list,
            method: "GET",
          }),

        ]);

        // Handle errors in either response
        if (followingRes?.status === 200 && !followingRes?.data?.errors) {
          const followingData = followingRes?.data?.user_follower_list?.data || [];
          setFollowingData(followingData);
        } else {
          console.error("Organized safari error:", followingRes?.data?.errors);
        }



      } catch (err) {
        console.error("Error in parallel fetch:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userProfileView?.urls?.followings_list]);

  const processedFollowingData = useMemo(() => {
    return following?.map((follower) => ({
      ...follower,
    }));
  }, [following]);


  return (
    <>
      <Row className="mb-5 itenary_tabs">
        <Col md={12} className="">
          <h6 className="fs-5 fw-bold pb-3">Following</h6>
        </Col>
        <Col xs={12}>
          <Card className="safartabs">
            <Card.Body>
              <Tab.Container defaultActiveKey="follower">
                <Nav
                  className="nav  nav-tabs border-bottom"
                  id="myTab"
                  role="tablist"
                >
                  <Nav.Item role="presentation">
                    <Nav.Link eventKey="follower" className="nav-link">
                      Profile Following
                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content className="pt-4">
                  <Tab.Pane eventKey="follower">
                    <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-5">
                      {Array.isArray(processedFollowingData) &&
                        processedFollowingData.length > 0 ? (
                        <>
                          {processedFollowingData.map((follower, index) => (
                            <Col
                              md={6} sm={6} lg={4} className="mb-4"
                              key={follower.id || index}
                            >
                              <Col className="mb-3">
                                <Card className="card_profile h-100 position-relative">
                                  <div className="dots-blockbox">
                                    <i className="fa-solid fa-ellipsis"></i>
                                    <div
                                      className="box_dropdown"
                                      style={{ display: "none block" }}
                                    >
                                      <Link to="" className="d-block pb-1">
                                        Viwe Profile
                                      </Link>
                                      <Link to="" className="d-block">
                                        Block
                                      </Link>
                                    </div>
                                  </div>
                                  <div className="profileDetails text-center">
                                    <Link to="">
                                      <div
                                        className="mx-auto white"
                                        style={{
                                          width: "70px",
                                          height: "70px",
                                        }}
                                      >
                                        <img
                                          src={follower?.profile_display_image || UserImg}
                                          className="rounded-circle img-fluid"
                                          alt="profile-image"
                                        />
                                      </div>
                                      <Card.Body className="text-center pt-2">
                                        <h6 className="fs-7 fw-bold usename">
                                          {follower?.display_name} Safaris
                                        </h6>
                                        <h6 className="fs-6 joint-text">
                                          {formatDateMonthYear(follower?.joined_at)}
                                        </h6>
                                        {/*<div className="followres-count pt-3">
                                          <div className="folloerwstext">
                                            219 Followers
                                          </div>
                                        </div> */}
                                      </Card.Body>
                                    </Link>

                                    <div className="followunfollowbtn border-top">
                                      <Row>
                                        <Col xs={6} className="divider">
                                          <div className="folollowBtns">
                                            <Link to="" data-method="POST">
                                              Follow
                                            </Link>
                                          </div>
                                        </Col>
                                        <Col xs={6}>
                                          <div className="massegses">
                                            <Link to="">Message</Link>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Card>
                              </Col>
                            </Col>
                          ))}
                        </>
                      ) :
                        <p>No Following Found</p>
                      }

                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Following;
